
import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import routes from "routes.js";
import { isOrderABusByNamingConvention } from "components/Orders/helpers";

var TableStyle = (function() {

    const badges = {
      "pink":"badge badge-pink",
      "warning":"badge badge-warning",
      "success":"badge badge-success",
      "danger":"badge badge-danger",
    }
    var getRowClasses = function (row, statusObj) {
      // Logic follows orders organization in get_orders_q() (backend orders controller)
      // Change both at the same time if making changes to this file
  
      let classes = "order_id_" + row.id + " ";
      // MX classes
      if (row.mx_status == "Crossing" || row.mx_status == "US Customs" || row.mx_status == "MX Customs") {
        classes += "light_red";
      } else if (row.mx_status == "On-site at the Border" && row.mx_documents.includes("DODA")) {
        classes += "bblue";
      } else if (String(row.terminal) == "8" && row.mx_documents == "DODA") {
        classes += "bblue";
      }
      else if (row.mx_documents.includes("Manifest")) {
        classes += "bg-green";
      }

      return classes;
    }

    var getNonMXRowClasses = function (row) {
      // Non MX classes
      let classes = "";
      const bus = isOrderABusByNamingConvention(row)
      if (bus) {
        classes += `bus-class-${bus}`;
      }
      return classes;
    }

    var GetTeamClasses = function (row)
    {
      let classes = "";
      if(row.mx_team == "RXO")
      {
        classes = badges.pink;
      }
      else if (row.mx_team == "AAMG")
      {
        classes = badges.warning;
      }  
      else if (row.mx_team == "MX Customers")
      {
        classes = badges.success;
      }
      return classes;
    }

    var GetDocumentsClasses = function (row)
    {
      let classes = "";
      if(row.mx_documents.length > 2 && row.mx_documents != 0)
      {
        classes = "badge badge-warning";
      }  
      if (row.mx_documents.includes("DODA") && row.mx_documents.includes("Prefile"))
      {
        classes = "badge badge-success";
      }
      else
      {
        classes = "badge badge-danger";
      }
      return classes;
    }

    var GetProgressBarClasses = function (width)
    {
      let classes = "progress-bar progress-bar-striped ";
      width = width ? width : 0;
      if (width >= 0 && width <= 25) {
        classes += "bg-danger";
      } else if (width > 25 && width <= 50) {
        classes += "bg-warning";
      } else if (width > 50 && width <= 75) {
        classes += "bg-info";
      } else if (width > 75 && width <= 100) {
        classes += "bg-success";
      } else {
        classes += "bg-info";
      }
      return classes;
    }
    
    var GetStatusClasses = function (row) {
      if (!row.dock) {
        return "";
      }
      
      let classes = "";
      if (row.dock.toLowerCase() == "yes")
      {
        classes = "badge badge-success"
      }
      return classes;
    }
    var GetLengthClasses = function (value)
    {
      let classes = ""
      if (value > 94)
      {
        classes = "badge badge-danger"
      }
      return classes
    }
    var GetTotalLengthClasses = function (value)
    {
      let classes = ""
      if (value > 636)
      {
        classes = "badge badge-danger"
      }
      return classes
    }

    var CheckEmptyClasses = function (value)
    {
      let classes = "";
      if (value == "")
      {
        classes = badges.danger;
      }
      return classes;
    }

    return {
      getRowClasses: getRowClasses,
      getNonMXRowClasses: getNonMXRowClasses,
      GetTeamClasses: GetTeamClasses,
      GetDocumentsClasses:GetDocumentsClasses,
      GetProgressBarClasses:GetProgressBarClasses,
      GetStatusClasses:GetStatusClasses,
      CheckEmptyClasses:CheckEmptyClasses,
      GetLengthClasses:GetLengthClasses,
      GetTotalLengthClasses:GetTotalLengthClasses
    }
  
  })();
  
  export default TableStyle;
